import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-grave-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-grave-cm.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { FormControl, FormGroup } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationService } from "../../../view-application.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationProfessionalBodiesWConstants } from "../../w/view-application-professional-bodies-w/view-application-professional-bodies-w.constants";
import { ViewApplicationGraveCmConstants } from "./view-application-grave-cm.constants";
import { MapService } from "../../../../../map/shared/map.service";
import Query from "@arcgis/core/rest/support/Query";
import { AlertType } from "../../../../../shared/models/alert";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let ViewApplicationGraveCmComponent = class ViewApplicationGraveCmComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    mapService;
    routerParamsService;
    appController;
    requestStatusService;
    viewApplicationService;
    changeDetectorRefs;
    graveForm;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    graveFormControlName = ViewApplicationGraveCmConstants.GRAVE_FORM_CONTROL_NAME;
    cemeteryFormControlName = ViewApplicationGraveCmConstants.CEMETERY_FORM_CONTROL_NAME;
    plotNoTypeFormControlName = ViewApplicationGraveCmConstants.PLOT_NO_FORM_CONTROL_NAME;
    graveStatusFormControlName = ViewApplicationGraveCmConstants.GRAVE_STATUS_FORM_CONTROL_NAME;
    conditionFormControlName = ViewApplicationGraveCmConstants.CONDITION_FORM_CONTROL_NAME;
    capacityFormControlName = ViewApplicationGraveCmConstants.CAPACITY_FORM_CONTROL_NAME;
    markerInscriptionTypeFormControlName = ViewApplicationGraveCmConstants.MARKER_INSCRIPTION_FORM_CONTROL_NAME;
    markerTypeFormControlName = ViewApplicationGraveCmConstants.MARKER_TYPE_FORM_CONTROL_NAME;
    graveLabel = ViewApplicationGraveCmConstants.GRAVE_LABEL;
    cemeteryLabel = ViewApplicationGraveCmConstants.CEMETERY_LABEL;
    plotNoLabel = ViewApplicationGraveCmConstants.PLOT_NO_LABEL;
    graveStatusLabel = ViewApplicationGraveCmConstants.GRAVE_STATUS_LABEL;
    conditionLabel = ViewApplicationGraveCmConstants.CONDITION_LABEL;
    capacityLabel = ViewApplicationGraveCmConstants.CAPACITY_LABEL;
    markerLabel = ViewApplicationGraveCmConstants.MARKER_INSCRIPTION_LABEL;
    markerTypeLabel = ViewApplicationGraveCmConstants.MARKER_TYPE_LABEL;
    graveOptions = [];
    validGraveInformation = null;
    selectedGrave = null;
    invalidGraveInformation = ViewApplicationGraveCmConstants.INVALID_GRAVE_INFORMATION;
    loadingGraveInformation = ViewApplicationGraveCmConstants.LOADING_GRAVE_INFORMATION;
    showGraveDropdown = true;
    noGraveSelectedText = ViewApplicationGraveCmConstants.NO_GRAVE_SELECTED_FOR_APPLICATION;
    mapComponent;
    application;
    graveLayer;
    cemeteryLayer;
    dropdownSelected = false;
    selectedSingleValue = false;
    constructor(aflaModuleStrategyService, route, mapService, routerParamsService, appController, requestStatusService, viewApplicationService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.mapService = mapService;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.requestStatusService = requestStatusService;
        this.viewApplicationService = viewApplicationService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.initForm();
    }
    ngOnInit() {
        this.listenForRouteParamChange();
    }
    mapLoaded() {
        this.graveLayer = this.mapService.userMaps.find(a => a.selectionLayerType === "Grave")?.layer;
        this.cemeteryLayer = this.mapService.userMaps.find(a => a.selectionLayerType === "Cemetery")?.layer;
        this.getApplication();
    }
    getApplication() {
        const params = {
            $expand: `graves`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationProfessionalBodiesWConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    graveChanged() {
        this.requestStatusService.showBusySpinner("Fetching grave information");
        this.validGraveInformation = null;
        this.selectedGrave = this.graveForm.get(this.graveFormControlName).value;
        if (this.graveLayer !== null && this.selectedGrave !== null) {
            const geometries = [];
            const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedGrave.shape, 102100);
            const geom = JsonUtils.fromJSON(geometryArc);
            geometries.push(geom);
            this.mapComponent.addGeometriesOnMap(geometries, "View grave", true);
            const graveQuery = new Query();
            graveQuery.where = `OBJECTID = ${this.selectedGrave.graveId}`;
            graveQuery.returnGeometry = false;
            graveQuery.outFields = ["*"];
            this.graveLayer.queryFeatures(graveQuery).then((graveFeatureSet) => {
                if (graveFeatureSet.features.length === 0) {
                    this.requestStatusService.removeBusySpinner("Fetching grave information");
                    this.validGraveInformation = false;
                    this.appController.showMessage(ViewApplicationGraveCmConstants.INVALID_GRAVE_ID, AlertType.Warning);
                    this.validGraveInformation = false;
                }
                else if (graveFeatureSet.features.length > 1) {
                    this.requestStatusService.removeBusySpinner("Fetching grave information");
                    this.appController.showMessage(ViewApplicationGraveCmConstants.MULTIPLE_GRAVE_ID, AlertType.Warning);
                }
                else {
                    this.validGraveInformation = true;
                    const grave = graveFeatureSet.features[0];
                    grave.attributes.hasOwnProperty("PlotNumber") ? this.graveForm.get(this.plotNoTypeFormControlName).setValue(grave.attributes.PlotNumber) : this.graveForm.get(this.plotNoTypeFormControlName).setValue(null);
                    grave.attributes.hasOwnProperty("Capacity") ? this.graveForm.get(this.capacityFormControlName).setValue(grave.attributes.Capacity) : this.graveForm.get(this.capacityFormControlName).setValue(null);
                    grave.attributes.hasOwnProperty("MarkerInscription") ? this.graveForm.get(this.markerInscriptionTypeFormControlName).setValue(grave.attributes.MarkerInscription) : this.graveForm.get(this.markerInscriptionTypeFormControlName).setValue(null);
                    grave.attributes.hasOwnProperty("GraveStatus") ? this.graveForm.get(this.graveStatusFormControlName).setValue(grave.attributes.GraveStatus) : this.graveForm.get(this.graveStatusFormControlName).setValue(null);
                    grave.attributes.hasOwnProperty("Condition") ? this.graveForm.get(this.conditionFormControlName).setValue(grave.attributes.Condition) : this.graveForm.get(this.conditionFormControlName).setValue(null);
                    grave.attributes.hasOwnProperty("MarkerType") ? this.graveForm.get(this.markerTypeFormControlName).setValue(grave.attributes.MarkerType) : this.graveForm.get(this.markerTypeFormControlName).setValue(null);
                    const cemeteryId = grave.attributes.hasOwnProperty("CemeteryID") ? grave.attributes.CemeteryID : null;
                    this.changeDetectorRefs.detectChanges();
                    if (this.cemeteryLayer !== null && cemeteryId !== null) {
                        const cemeteryQuery = new Query();
                        cemeteryQuery.where = `OBJECTID = ${cemeteryId}`;
                        cemeteryQuery.returnGeometry = false;
                        cemeteryQuery.outFields = ["*"];
                        this.cemeteryLayer.queryFeatures(cemeteryQuery).then((cemeteryFeatureSet) => {
                            if (cemeteryFeatureSet.features.length === 0) {
                                this.appController.showMessage(ViewApplicationGraveCmConstants.INVALID_CEMETERY_ID, AlertType.Warning);
                            }
                            else if (cemeteryFeatureSet.features.length > 1) {
                                this.appController.showMessage(ViewApplicationGraveCmConstants.MULTIPLE_CEMETERY_ID, AlertType.Warning);
                            }
                            else {
                                const cemetery = cemeteryFeatureSet.features[0];
                                cemetery.attributes.hasOwnProperty("Name") ? this.graveForm.get(this.cemeteryFormControlName).setValue(cemetery.attributes.Name) : this.graveForm.get(this.cemeteryFormControlName).setValue(null);
                                this.changeDetectorRefs.detectChanges();
                            }
                            this.requestStatusService.removeBusySpinner("Fetching grave information");
                        }, (error) => {
                            this.requestStatusService.removeBusySpinner("Fetching grave information");
                            this.appController.showMessage(error.message, AlertType.Error);
                        });
                    }
                    else {
                        this.requestStatusService.removeBusySpinner("Fetching grave information");
                        if (this.cemeteryLayer === null) {
                            this.appController.showMessage(ViewApplicationGraveCmConstants.NO_CEMETERY_LAYER_CONFIGURED, AlertType.Warning);
                        }
                        else if (cemeteryId === null) {
                            this.appController.showMessage(ViewApplicationGraveCmConstants.NO_CEMETERY_LINKED_TO_GRAVE, AlertType.Warning);
                        }
                    }
                }
            }, (error) => {
                this.requestStatusService.removeBusySpinner("Fetching grave information");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            this.requestStatusService.removeBusySpinner("Fetching grave information");
            if (this.graveLayer === null) {
                this.appController.showMessage(ViewApplicationGraveCmConstants.NO_GRAVE_LAYER_CONFIGURED, AlertType.Warning);
            }
            else if (this.selectedGrave === null) {
                this.appController.showMessage(ViewApplicationGraveCmConstants.NO_GRAVE_SELECTED, AlertType.Warning);
            }
        }
    }
    handleRouteChange() {
    }
    initForm() {
        const form = new FormGroup({
            grave: new FormControl(null),
            cemeteryName: new FormControl({ value: null, disabled: true }),
            plotNumber: new FormControl({ value: null, disabled: true }),
            graveStatus: new FormControl({ value: null, disabled: true }),
            condition: new FormControl({ value: null, disabled: true }),
            capacity: new FormControl({ value: null, disabled: true }),
            markerInscription: new FormControl({ value: null, disabled: true }),
            markerType: new FormControl({ value: null, disabled: true })
        });
        this.graveForm = form;
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.application = response.value[0];
            this.graveOptions = this.application.graves;
            this.showGraveDropdown = true;
            this.dropdownSelected = true;
            if (this.application.graves.length === 1) {
                this.graveForm.get(this.graveFormControlName).setValue(this.application.graves[0]);
                this.selectedSingleValue = !this.selectedSingleValue;
                this.graveChanged();
            }
            if (this.application.graves.length === 0) {
                this.showGraveDropdown = false;
            }
            this.changeDetectorRefs.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: MapService },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: RequestStatusService },
        { type: ViewApplicationService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationGraveCmComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-grave-cm",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationGraveCmComponent);
export { ViewApplicationGraveCmComponent };
